import { NgModule } from '@angular/core';
import { NZ_ICONS, NzIconModule } from 'ng-zorro-antd/icon';

import {
  MenuFoldOutline,
  MenuUnfoldOutline,
  FormOutline,
  DashboardOutline,
  QuestionOutline,
  ProfileOutline,
  QuestionCircleOutline,
  UserOutline,
  LogoutOutline,
  InfoOutline,
  InfoCircleOutline,
  LockOutline,
  UnlockOutline,
  CloseCircleFill,
  CloseCircleOutline,
  PlusCircleOutline,
  EditOutline,
  DeleteOutline,
  CloseOutline,
  FileExcelOutline,
  LoginOutline,
  ProjectOutline,
  AuditOutline,
  SettingOutline,
  FileSearchOutline,
  FolderOpenOutline,
  CheckSquareOutline,
  TeamOutline,
  CameraOutline,
  ArrowLeftOutline,
  StopOutline,
  DownloadOutline,
  FileTwoTone, BorderVerticleOutline, ArrowUpOutline, ArrowDownOutline,
  PlusOutline,
  RightCircleOutline,
  AppstoreOutline,
  BuildOutline,
  EyeInvisibleOutline,
  DatabaseOutline,
  SafetyCertificateOutline,
  ScanOutline,
  EnterOutline,
  RollbackOutline,
  MenuOutline,
  RedoOutline,
  BankOutline,
} from '@ant-design/icons-angular/icons';

const icons = [
  MenuFoldOutline,
  MenuUnfoldOutline,
  DashboardOutline,
  FormOutline,
  QuestionOutline,
  ProfileOutline,
  QuestionCircleOutline,
  UserOutline,
  LogoutOutline,
  InfoOutline,
  InfoCircleOutline,
  InfoCircleOutline,
  LockOutline,
  UnlockOutline,
  CloseCircleFill,
  CloseCircleOutline,
  PlusCircleOutline,
  EditOutline,
  DeleteOutline,
  CloseOutline,
  FileExcelOutline,
  LoginOutline,
  ProjectOutline,
  AuditOutline,
  SettingOutline,
  FileSearchOutline,
  FolderOpenOutline,
  CheckSquareOutline,
  TeamOutline,
  CameraOutline,
  ArrowLeftOutline,
  StopOutline,
  DownloadOutline,
  FileTwoTone,
  BorderVerticleOutline,
  ArrowUpOutline,
  ArrowDownOutline,
  PlusOutline,
  RightCircleOutline,
  AppstoreOutline,
  BuildOutline,
  EyeInvisibleOutline,
  DatabaseOutline,
  SafetyCertificateOutline,
  ScanOutline,
  EnterOutline,
  RollbackOutline,
  MenuOutline,
  RedoOutline,
  BankOutline,
];

@NgModule({
  imports: [NzIconModule],
  exports: [NzIconModule],
  providers: [
    { provide: NZ_ICONS, useValue: icons }
  ]
})
export class IconsProviderModule {
}
